import { ModalState } from "../../../../types/types";
import { PricingCategory } from "../../../constants";
import PricingsByExpenseTypeForm from "../workAndAbscences/PricingsByExpenseTypeForm";
import i18n from "../../../../../../i18n";

export const EDIT_BUTTON_TEXT = i18n.t(
  "customers:contract.pricingBySalaryType",
);
export const VIEW_BUTTON_TEXT = i18n.t(
  "customers:contract.showPricingBySalaryTypeInformation",
);

const getSpecialPricingBySalaryTypeModalDefaultProps = (
  categoryKey: PricingCategory,
  tesId: string,
  onCloseModal: () => void,
  disabled: boolean,
  canEdit: boolean,
  dragHandleSelector: string,
) => {
  return {
    tesId: tesId!, // cannot be null here
    mainFormPropertyKey: categoryKey,
    expenseTypeCategoryFilter: categoryKey,
    modalTitle: i18n.t("customers:contract.pricingBySalaryType"),
    rowLabel: i18n.t("customers:contract.salaryType"),
    inputLabel: i18n.t("customers:contract.searchSalaryTypes"),
    addButtonLabel: i18n.t("customers:contract.pricingBySalaryType"),
    confirmDialogTitle: i18n.t(
      "customers:contract.pricingBySalaryTypeDeleteConfirmTitle",
    ),
    confirmDialogContentText: i18n.t(
      "customers:contract.pricingBySalaryTypeDeleteConfirmText",
    ),
    onClose: onCloseModal,
    disabled,
    canEdit,
    dragHandleSelector: dragHandleSelector,
    hideOverrideOption: true,
  };
};

export const getSpecialPricingByExpenseTypeModalContent = (
  modalState: ModalState,
  tesId: string,
  onCloseModal: () => void,
  disabled: boolean,
  canEdit: boolean,
  dragHandleSelector: string,
) => {
  switch (modalState.id) {
    case PricingCategory.BaseHours:
      return (
        <PricingsByExpenseTypeForm
          {...getSpecialPricingBySalaryTypeModalDefaultProps(
            PricingCategory.BaseHours,
            tesId,
            onCloseModal,
            disabled,
            canEdit,
            dragHandleSelector,
          )}
        />
      );
    case PricingCategory.Supplements:
      return (
        <PricingsByExpenseTypeForm
          {...getSpecialPricingBySalaryTypeModalDefaultProps(
            PricingCategory.Supplements,
            tesId,
            onCloseModal,
            disabled,
            canEdit,
            dragHandleSelector,
          )}
        />
      );
    default:
      return <></>;
  }
};
